export default __webpack_public_path__ + "static/media/08.2ceaed8c.jpg";